<mat-label>{{ props.description }}</mat-label>
<textarea
  title="Text Area"
  class="json-edit-area"
  [formControl]="formControl"
  [formlyAttributes]="field"
  json
></textarea>
